import { AppConfig } from "@/config/app.config";
import { HelpData } from "@/models/help";

/**
 * Load batch-specific help data
 * @param userBatch - Optional batch identifier. If not provided, uses localStorage or DEFAULT_BATCH
 * @returns Promise with help data
 */
export const loadHelpData = async (userBatch?: string): Promise<HelpData> => {
  try {
    // Priority: 1) User's batch (from Firestore), 2) localStorage, 3) default
    const selectedBatch = userBatch || localStorage.getItem("selectedBatch") || AppConfig.DEFAULT_BATCH;

    // Get the help data file for the selected batch from config
    const batchConfig = AppConfig.BATCHES[selectedBatch];
    const helpDataFile = batchConfig?.helpDataFile || AppConfig.DEFAULTS.helpDataFile;

    // Fetch the help data
    const response = await fetch(`/data/${helpDataFile}`);
    if (!response.ok) {
      throw new Error(`Failed to load help data: ${response.statusText}`);
    }
    
    const helpData: HelpData = await response.json();
    return helpData;
  } catch (error) {
    console.error("Error loading help data:", error);
    throw error;
  }
};

